import { createContext } from 'react';

import { DEFAULT_DATASET_TYPE } from '../constants.js';

/***
 * @internal
 */
export type HoneycombDatasetType = 'numeric' | 'categorical';

export const HoneycombDatasetTypeContext =
  createContext<HoneycombDatasetType>(DEFAULT_DATASET_TYPE);
